import type { MCPServerId, MCPServerInfo } from './types';
export * from './constants';
export * from './types';
export * from './util';

import AirtableServer from './server_templates/airtable';
import ApiiroServer from './server_templates/apiiro';
import CyeraDataportServer from './server_templates/cyera_dataport';
import ExcalidrawServer from './server_templates/excalidraw';
import LaunchDarklyServer from './server_templates/launchdarkly';
import LaunchDarklyOfficialServer from './server_templates/launchdarkly_official';
import LinearServer from './server_templates/linear';
import ToriiServer from './server_templates/torii';
import AirweaveSearchServer from './server_templates/airweave-search';
import AmplitudeServer from './server_templates/amplitude';
import AsanaServer from './server_templates/asana';
import AshbyServer from './server_templates/ashby';
import AshbyNatomaServer from './server_templates/ashby_natoma';
import AtlassianServer from './server_templates/atlassian';
import AzureDevOpsServer from './server_templates/azure_devops';
import AtlassianRemoteServer from './server_templates/atlassian_remote';
import AvalaraDevDocumentationServer from './server_templates/avalara_dev_documentation';
import AvalaraTaxContentServer from './server_templates/avalara_tax_content';
import AvataxServer from './server_templates/avatax';
import AwsCloudWatchServer from './server_templates/aws_cloudwatch';
import AwsCostExplorerServer from './server_templates/aws_cost_explorer';
import AwsDocumentationServer from './server_templates/aws_documentation';
import AwsIamServer from './server_templates/aws_iam';
import BoxServer from './server_templates/box';
import BigQueryRemoteServer from './server_templates/bigquery_remote';
import BraveServer from './server_templates/brave_search';
import BrazeServer from './server_templates/braze';
import BullhornCRMServer from './server_templates/bullhorn_crm';
import BuildkiteServer from './server_templates/buildkite';
import CheckmarxServer from './server_templates/checkmarx';
import ChemblServer from './server_templates/chembl';
import ChromeDevtoolsServer from './server_templates/chrome_devtools';
import CircleciServer from './server_templates/circleci';
import ClickupServer from './server_templates/clickup';
import ClojureServer from './server_templates/clojure';
import CloudZeroServer from './server_templates/cloudzero';
import {
  CloudflareAuditLogsServer,
  CloudflareWorkersObservabilityServer
} from './server_templates/cloudflare';
import Context7Server from './server_templates/context7';
import Context7OAuthServer from './server_templates/context7_oauth';
import CrowdstrikeServer from './server_templates/crowdstrike';
import CustomApiServerServer from './server_templates/custom-api-server';
import DailymedServer from './server_templates/dailymed';
import DatabricksServer from './server_templates/databricks';
import DatadogCommunityServer from './server_templates/datadog_community';
import DataforseoServer from './server_templates/dataforseo';
import DataHubServer from './server_templates/datahub';
import DovetailServer from './server_templates/dovetail';
import DrawioServer from './server_templates/drawio';
import DropboxServer from './server_templates/dropbox';
import FetchServer from './server_templates/fetch';
import FigmaServer from './server_templates/figma';
import FigmaDesktopServer from './server_templates/figma_desktop';
import FilesystemServer from './server_templates/filesystem';
import FirecrawlServer from './server_templates/firecrawl';
import FirefliesServer from './server_templates/fireflies';
import FreshserviceServer from './server_templates/freshservice';
import FullstoryLexiconServer from './server_templates/fullstory_lexicon';
import GenaiToolboxServer from './server_templates/genai_toolbox';
import GenaiToolboxBigQueryServer from './server_templates/genai_toolbox_bigquery';
import GenaiToolboxLookerServer from './server_templates/genai_toolbox_looker';
import GenaiToolboxOracleDBServer from './server_templates/genai_toolbox_oracledb';
import GenaiToolboxPostgresServer from './server_templates/genai_toolbox_postgres';
import GithubServer from './server_templates/github';
import GithubOAuthServer from './server_templates/github_oauth';
import GithubStdioServer from './server_templates/github_stdio';
import GitlabServer from './server_templates/gitlab';
import GitlabRemoteServer from './server_templates/gitlab_remote';
import GleanServer from './server_templates/glean';
import GongServer from './server_templates/gong';
import GongCommunityServer from './server_templates/gong_community';
import GrafanaServer from './server_templates/grafana';
import GoogleCalendarServer from './server_templates/google_calendar';
import GoogleCalendarOfficialServer from './server_templates/google_calendar_official';
import GoogleChatServer from './server_templates/google_chat';
import GoogleDocsServer from './server_templates/google_docs';
import GoogleDriveServer from './server_templates/google_drive';
import GoogleDriveOfficialServer from './server_templates/google_drive_official';
import GoogleFormsServer from './server_templates/google_forms';
import GoogleGmailServer from './server_templates/google_gmail';
import GoogleGmailOfficialServer from './server_templates/google_gmail_official';
import GooglePeopleServer from './server_templates/google_people';
import GoogleSheetsServer from './server_templates/google_sheets';
import GoogleSlidesServer from './server_templates/google_slides';
import GoogleWorkspaceServer from './server_templates/google_workspace';
import GraphitiServer from './server_templates/graphiti';
import GreenhouseServer from './server_templates/greenhouse';
import CnaGwreDeveloperAssistantServer from './server_templates/cna_gwre_developer_assistant';
import CnaJutroDeveloperAssistantServer from './server_templates/cna_jutro_developer_assistant';
import HarnessServer from './server_templates/harness';
import HerokuServer from './server_templates/heroku';
import HoneycombServer from './server_templates/honeycomb';
import HubspotServer from './server_templates/hubspot';
import IncidentioServer from './server_templates/incidentio';
import IntercomServer from './server_templates/intercom';
import InvideoServer from './server_templates/invideo';
import IterableServer from './server_templates/iterable';
import JenkinsServer from './server_templates/jenkins';
import JfrogServer from './server_templates/jfrog';
import LinxServer from './server_templates/linx';
import LucidServer from './server_templates/lucid';
import MdapiServer from './server_templates/mdapi';
import Microsoft365Server from './server_templates/microsoft365';
import MicrosoftGraphAndArmServer from './server_templates/microsoft_graph_and_arm';
import MiroServer from './server_templates/miro';
import MiroOfficialServer from './server_templates/miro_official';
import MixpanelServer from './server_templates/mixpanel';
import MockServer from './server_templates/mock_server';
import MongodbServer from './server_templates/mongodb';
import MotherduckServer from './server_templates/motherduck';
import NeonServer from './server_templates/neon';
import NetsuiteServer from './server_templates/netsuite';
import NewRelicServer from './server_templates/new_relic';
import NotionServer from './server_templates/notion';
import OktaNatomaServer from './server_templates/okta_natoma';
import OktaCommunityServer from './server_templates/okta_community';
import PagerDutyRemoteServer from './server_templates/pagerduty';
import PaypalServer from './server_templates/paypal';
import PerplexityAskServer from './server_templates/perplexity_ask';
import PineconeServer from './server_templates/pinecone-mcp';
import PlaidServer from './server_templates/plaid';
import PlaywrightServer from './server_templates/playwright';
import PowerBiServer from './server_templates/power_bi';
import PlaywrightLocalServer from './server_templates/playwright_local';
import PrismaServer from './server_templates/prisma';
import PrometheusServer from './server_templates/prometheus';
import PubchemServer from './server_templates/pubchem';
import PubmedServer from './server_templates/pubmed';
import RedisServer from './server_templates/redis';
import ResendServer from './server_templates/resend';
import SailpointServer from './server_templates/sailpoint';
import ScalrServer from './server_templates/scalr';
import SalesforceServer from './server_templates/salesforce';
import SalesforceRemoteServer from './server_templates/salesforce_remote';
import SelectStarServer from './server_templates/select-star';
import SemgrepServer from './server_templates/semgrep';
import SentinelOneServer from './server_templates/sentinelone';
import SentryServer from './server_templates/sentry';
import SequentialthinkingServer from './server_templates/sequentialthinking';
import ServicenowServer from './server_templates/servicenow';
import ServicenowRemoteServer from './server_templates/servicenow_remote';
import SlackBetaServer from './server_templates/slack_beta';
import SlackCommunityServer from './server_templates/slack_community';
import SlackRemoteServer from './server_templates/slack_remote';
import SmartbearServer from './server_templates/smartbear';
import SnowflakeServer from './server_templates/snowflake';
import SonarqubeServer from './server_templates/sonarqube';
import SourcebotServer from './server_templates/sourcebot';
import SpaceliftServer from './server_templates/spacelift';
import SpinachServer from './server_templates/spinach';
import SplunkServer from './server_templates/splunk';
import SquareServer from './server_templates/square';
import StatsigServer from './server_templates/statsig';
import StarWarsServer from './server_templates/star_wars';
import StripeServer from './server_templates/stripe';
import SupabaseServer from './server_templates/supabase';
import SupernovaServer from './server_templates/supernova';
import TableauServer from './server_templates/tableau';
import TeradataServer from './server_templates/teradata';
import TimeServer from './server_templates/time';
import UpwindServer from './server_templates/upwind';
import UsPtoServer from './server_templates/us-pto';
import VegaServer from './server_templates/vega';
import WebflowServer from './server_templates/webflow';
import WizServer from './server_templates/wiz';
import WorkatoServer from './server_templates/workato';
import WrikeServer from './server_templates/wrike';
import ZapierServer from './server_templates/zapier';
import ZoomServer from './server_templates/zoom';
import ZoomRemoteServer from './server_templates/zoom_remote';
import ZoomInfoServer from './server_templates/zoominfo';
import KubernetesServer from './server_templates/kubernetes';
import NotebookLMServer from './server_templates/notebooklm';

export const MCPServerInfoMap: {
  [key in MCPServerId]: MCPServerInfo;
} = {
  AIRTABLE: AirtableServer,
  AIRWEAVE_SEARCH: AirweaveSearchServer,
  AMPLITUDE: AmplitudeServer,
  APIIRO: ApiiroServer,
  ASANA: AsanaServer,
  ASHBY: AshbyServer,
  ASHBY_NATOMA: AshbyNatomaServer,
  ATLASSIAN: AtlassianServer,
  ATLASSIAN_REMOTE: AtlassianRemoteServer,
  AVALARA_DEV_DOCUMENTATION: AvalaraDevDocumentationServer,
  AVALARA_TAX_CONTENT: AvalaraTaxContentServer,
  AVATAX: AvataxServer,
  AZURE_DEVOPS: AzureDevOpsServer,
  AWS_CLOUDWATCH: AwsCloudWatchServer,
  BIGQUERY_REMOTE: BigQueryRemoteServer,
  AWS_COST_EXPLORER: AwsCostExplorerServer,
  AWS_DOCUMENTATION: AwsDocumentationServer,
  AWS_IAM: AwsIamServer,
  BOX: BoxServer,
  BRAVE: BraveServer,
  BRAZE: BrazeServer,
  BULLHORN_CRM: BullhornCRMServer,
  BUILDKITE: BuildkiteServer,
  CHECKMARX: CheckmarxServer,
  CHEMBL: ChemblServer,
  CHROME_DEVTOOLS: ChromeDevtoolsServer,
  CIRCLECI: CircleciServer,
  CLOUDFLARE_AUDIT_LOGS: CloudflareAuditLogsServer,
  CLOUDFLARE_WORKERS_OBSERVABILITY: CloudflareWorkersObservabilityServer,
  CLOUDZERO: CloudZeroServer,
  CLICKUP: ClickupServer,
  CLOJURE: ClojureServer,
  CONTEXT7: Context7Server,
  CONTEXT7_OAUTH: Context7OAuthServer,
  CROWDSTRIKE: CrowdstrikeServer,
  CUSTOM_API_SERVER: CustomApiServerServer,
  CYERA_DATAPORT: CyeraDataportServer,
  DAILYMED: DailymedServer,
  DATABRICKS: DatabricksServer,
  DATADOG_COMMUNITY: DatadogCommunityServer,
  DATAFORSEO: DataforseoServer,
  DATAHUB: DataHubServer,
  DOVETAIL: DovetailServer,
  DRAWIO: DrawioServer,
  DROPBOX: DropboxServer,
  EXCALIDRAW: ExcalidrawServer,
  FETCH: FetchServer,
  FIGMA: FigmaServer,
  FIGMA_DESKTOP: FigmaDesktopServer,
  FILESYSTEM: FilesystemServer,
  FIRECRAWL: FirecrawlServer,
  FIREFLIES: FirefliesServer,
  FRESHSERVICE: FreshserviceServer,
  FULLSTORY_LEXICON: FullstoryLexiconServer,
  GENAI_TOOLBOX: GenaiToolboxServer,
  GENAI_TOOLBOX_BIGQUERY: GenaiToolboxBigQueryServer,
  GENAI_TOOLBOX_LOOKER: GenaiToolboxLookerServer,
  GENAI_TOOLBOX_ORACLEDB: GenaiToolboxOracleDBServer,
  GENAI_TOOLBOX_POSTGRES: GenaiToolboxPostgresServer,
  GITHUB: GithubServer,
  GITHUB_OAUTH: GithubOAuthServer,
  GITHUB_STDIO: GithubStdioServer,
  GITLAB: GitlabServer,
  GITLAB_REMOTE: GitlabRemoteServer,
  GLEAN: GleanServer,
  GONG: GongServer,
  GONG_COMMUNITY: GongCommunityServer,
  GRAFANA: GrafanaServer,
  GOOGLE_CALENDAR: GoogleCalendarServer,
  GOOGLE_CALENDAR_OFFICIAL: GoogleCalendarOfficialServer,
  GOOGLE_CHAT: GoogleChatServer,
  GOOGLE_DOCS: GoogleDocsServer,
  GOOGLE_DRIVE: GoogleDriveServer,
  GOOGLE_DRIVE_OFFICIAL: GoogleDriveOfficialServer,
  GOOGLE_FORMS: GoogleFormsServer,
  GOOGLE_GMAIL: GoogleGmailServer,
  GOOGLE_GMAIL_OFFICIAL: GoogleGmailOfficialServer,
  GOOGLE_PEOPLE: GooglePeopleServer,
  GOOGLE_SHEETS: GoogleSheetsServer,
  GOOGLE_SLIDES: GoogleSlidesServer,
  GOOGLE_WORKSPACE: GoogleWorkspaceServer,
  GRAPHITI: GraphitiServer,
  GREENHOUSE: GreenhouseServer,
  CNA_GWRE_DEVELOPER_ASSISTANT: CnaGwreDeveloperAssistantServer,
  CNA_JUTRO_DEVELOPER_ASSISTANT: CnaJutroDeveloperAssistantServer,
  HARNESS: HarnessServer,
  HEROKU: HerokuServer,
  HONEYCOMB: HoneycombServer,
  HUBSPOT: HubspotServer,
  INCIDENTIO: IncidentioServer,
  INTERCOM: IntercomServer,
  INVIDEO: InvideoServer,
  ITERABLE: IterableServer,
  JENKINS: JenkinsServer,
  JFROG: JfrogServer,
  KUBERNETES: KubernetesServer,
  LAUNCHDARKLY: LaunchDarklyServer,
  LAUNCHDARKLY_OFFICIAL: LaunchDarklyOfficialServer,
  LINEAR: LinearServer,
  LINX: LinxServer,
  LUCID: LucidServer,
  MDAPI: MdapiServer,
  MICROSOFT365: Microsoft365Server,
  MICROSOFT_GRAPH_AND_ARM: MicrosoftGraphAndArmServer,
  MIRO: MiroServer,
  MIRO_OFFICIAL: MiroOfficialServer,
  MIXPANEL: MixpanelServer,
  MOCK_SERVER: MockServer,
  MONGODB: MongodbServer,
  MOTHERDUCK: MotherduckServer,
  NEON: NeonServer,
  NETSUITE: NetsuiteServer,
  NEW_RELIC: NewRelicServer,
  NOTEBOOKLM: NotebookLMServer,
  NOTION: NotionServer,
  OKTA_NATOMA: OktaNatomaServer,
  OKTA_COMMUNITY: OktaCommunityServer,
  PAGERDUTY: PagerDutyRemoteServer,
  PAYPAL: PaypalServer,
  PERPLEXITY_ASK: PerplexityAskServer,
  PINECONE: PineconeServer,
  PLAID: PlaidServer,
  PLAYWRIGHT: PlaywrightServer,
  POWER_BI: PowerBiServer,
  PLAYWRIGHT_LOCAL: PlaywrightLocalServer,
  PRISMA: PrismaServer,
  PROMETHEUS: PrometheusServer,
  PUBCHEM: PubchemServer,
  PUBMED: PubmedServer,
  REDIS: RedisServer,
  RESEND: ResendServer,
  SAILPOINT: SailpointServer,
  SALESFORCE: SalesforceServer,
  SALESFORCE_REMOTE: SalesforceRemoteServer,
  SCALR: ScalrServer,
  SELECT_STAR: SelectStarServer,
  SEMGREP: SemgrepServer,
  SENTINELONE: SentinelOneServer,
  SENTRY: SentryServer,
  SEQUENTIALTHINKING: SequentialthinkingServer,
  SERVICENOW: ServicenowServer,
  SERVICENOW_REMOTE: ServicenowRemoteServer,
  SLACK_BETA: SlackBetaServer,
  SLACK_COMMUNITY: SlackCommunityServer,
  SLACK_REMOTE: SlackRemoteServer,
  SMARTBEAR: SmartbearServer,
  SNOWFLAKE: SnowflakeServer,
  SONARQUBE: SonarqubeServer,
  SOURCEBOT: SourcebotServer,
  SPACELIFT: SpaceliftServer,
  SPINACH: SpinachServer,
  SPLUNK: SplunkServer,
  SQUARE: SquareServer,
  STATSIG: StatsigServer,
  STAR_WARS: StarWarsServer,
  STRIPE: StripeServer,
  SUPABASE: SupabaseServer,
  SUPERNOVA: SupernovaServer,
  TABLEAU: TableauServer,
  TERADATA: TeradataServer,
  TIME: TimeServer,
  TORII: ToriiServer,
  UPWIND: UpwindServer,
  US_PTO: UsPtoServer,
  VEGA: VegaServer,
  WEBFLOW: WebflowServer,
  WIZ: WizServer,
  WORKATO: WorkatoServer,
  WRIKE: WrikeServer,
  ZAPIER: ZapierServer,
  ZOOM: ZoomServer,
  ZOOM_REMOTE: ZoomRemoteServer,
  ZOOMINFO: ZoomInfoServer
};

export const MCPServerInfoList: MCPServerInfo[] =
  Object.values(MCPServerInfoMap);

export const MCPServerInfoFirstParty: Record<MCPServerId, MCPServerInfo> =
  Object.fromEntries(
    Object.entries(MCPServerInfoMap).filter(([_, v]) => {
      if (v.authConfig?.creds) {
        return (
          'clientId' in v.authConfig.creds &&
          'clientSecret' in v.authConfig.creds
        );
      }
      return false;
    })
  ) as Record<MCPServerId, MCPServerInfo>;
